// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/af09c8c6375faa7f4f47.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"625b4cc61631ee0c4d91","137":"7ce17c07d3d44eef63c6","138":"1f3a77bf48bfdb590f57"}[chunkId] + ".chunk.js";
};